module.exports = __webpack_public_path__ + "img/practical.f7b6c5a5.svg";